import React from "react";
import { GeoJSON } from "react-leaflet";
import { reprojectWgToUtmPoint } from "../../../common/utmDef";
import {
  getCurrentObjectType,
  getCurrentObjectSubtype,
} from "../../../containers/Domain/geo-selectors/index";
import { stylePolygon } from "../../../utils/polygons/polygonStyle";
import { throttle } from "lodash";
import { point } from "@turf/helpers";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";
import { multiPolygon } from "@turf/helpers";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

class ChildRasterGeoJson extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onEachRasterGeoJsonFeature =
      this.onEachRasterGeoJsonFeature.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);

    this.activeTooltip = null;
  }

  componentDidMount() {
    if (
      this.props.childRasterPreviewRef?.current?.leafletElement &&
      this.props.childRasterPreview
    )
      this.props.childRasterPreviewRef.current.leafletElement
        .clearLayers()
        .addData(this.props.childRasterPreview);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (!prevProps.isChildRasterPreviewVisible &&
        this.props.isChildRasterPreviewVisible) ||
      (this.props.isChildRasterPreviewVisible &&
        this.props.childRasterPreview &&
        this.props.childRasterPreview !== prevProps.childRasterPreview)
    ) {
      this.props.childRasterPreviewRef.current.leafletElement
        .clearLayers()
        .addData(this.props.childRasterPreview);
    }
  }

  onEachRasterGeoJsonFeature = (feature, layer) => {
    this.activeTooltip = null;
    const throttledMouseMove = throttle(
      this.handleMouseMove(layer, feature),
      25
    );

    layer.on("mousemove", throttledMouseMove);
    layer.on("mouseout", this.handleMouseOut(layer));
  };

  handleMouseMove = (layer, feature) => (e) => {
    const { lat, lng } = e.latlng;
    const properties = feature.properties;

    const currentCursorCoodsUtm = reprojectWgToUtmPoint(
      {
        lat: lat,
        lng: lng,
      },
      this.props.crsDef
    );
    const childInfoLat = Math.ceil(
      (currentCursorCoodsUtm.lat - this.props.childRasterPreviewBbox[1]) /
        this.props.childGridSize
    );
    const childInfoLng = Math.ceil(
      (currentCursorCoodsUtm.lng - this.props.childRasterPreviewBbox[0]) /
        this.props.childGridSize
    );

    let parentDiv = "";

    if (this.props.isParentRasterPreviewVisible) {
      const coordsInfoLat = Math.ceil(
        (currentCursorCoodsUtm.lat - this.props.parentRasterPreviewBbox[1]) /
          this.props.parentGridSize
      );
      const coordsInfoLng = Math.ceil(
        (currentCursorCoodsUtm.lng - this.props.parentRasterPreviewBbox[0]) /
          this.props.parentGridSize
      );

      if (coordsInfoLat > 0 && coordsInfoLng > 0) {
        const clickedPoint = point([lng, lat]);

        this.props.parentRasterPreview.features.forEach((feature) => {
          if (feature.geometry.type === "MultiPolygon") {
            const multiPolygonn = multiPolygon(feature.geometry.coordinates);

            if (booleanPointInPolygon(clickedPoint, multiPolygonn)) {
              parentDiv =
                "<div style='z-index:100000'><div style='background:white; min-width:120px; padding:1px 3px 1px 3px'>" +
                `<div><strong>Parent: ${
                  feature.properties.t === 99
                    ? "Raster filling"
                    : feature.properties.t === 98
                    ? "Buffered area"
                    : this.props.t(getCurrentObjectType(feature.properties))
                }</strong>
             </div>
             ` +
                `<div> ${
                  feature.properties.t === 99 || feature.properties.t === 98
                    ? ""
                    : this.props.t(getCurrentObjectSubtype(feature.properties))
                }</div>` +
                `<div>x: ${coordsInfoLng}</div>` +
                `<div>y: ${coordsInfoLat}</div>` +
                "</div>";
            }
          }
        });
      }
    }

    let content =
      parentDiv +
      "<div style='z-index:100000'><div style='background:white; min-width:120px; padding:1px 3px 1px 3px'>" +
      `<div><strong> Child: ${
        properties.t === 99
          ? "Raster filling"
          : this.props.t(getCurrentObjectType(properties))
      }</strong>
 </div>
 ` +
      `<div> ${
        properties.t === 99
          ? ""
          : this.props.t(getCurrentObjectSubtype(properties))
      }</div>` +
      `<div>x: ${childInfoLng}</div>` +
      `<div>y: ${childInfoLat}</div>` +
      "</div>";

    if (this.activeTooltip) {
      this.activeTooltip.unbindTooltip();
    }

    this.activeTooltip = layer
      .bindTooltip(content, {
        permanent: false,
        direction: "top",
        sticky: true,
        opacity: 0.9,
      })
      .openTooltip(e.latlng);
  };

  handleMouseOut = (layer) => () => {
    if (this.activeTooltip) {
      this.activeTooltip.unbindTooltip();
      this.activeTooltip = null;
    }
  };

  render() {
    return (
      <>
        {this.props.isChildRasterPreviewVisible && (
          <GeoJSON
            ref={this.props.childRasterPreviewRef}
            style={(x) => {
              return stylePolygon(x, false, this.props.inputPalmTypesPalette);
            }}
            onEachFeature={this.onEachRasterGeoJsonFeature}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    childRasterPreview: state.rasterArea.childRasterPreview,
    isChildRasterPreviewVisible: state.rasterArea.isChildRasterPreviewVisible,
    inputPalmTypesPalette:
      state.userSettings?.settings?.visualizationPresets
        ?.inputPalmTypesPalette || {},
    parentRasterPreviewBbox: state.rasterArea.parentRasterPreviewBbox,
    crsDef: state.map.crsDef,
    parentGridSize: state.rasterArea.parentGridSize,
    isParentRasterPreviewVisible: state.rasterArea.isParentRasterPreviewVisible,
    parentRasterPreview: state.rasterArea.parentRasterPreview,
    childRasterPreviewBbox: state.rasterArea.childRasterPreviewBbox,
    childGridSize: state.rasterArea.childGridSize,
  };
};

export default withTranslation()(
  connect(mapStateToProps, null)(ChildRasterGeoJson)
);
